import { render, staticRenderFns } from "./TelaTabela.vue?vue&type=template&id=1c83a96b&scoped=true"
import script from "./TelaTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./TelaTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TelaTabela.vue?vue&type=style&index=0&id=1c83a96b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c83a96b",
  null
  
)

export default component.exports